import VTable from '@/vuetify_custom/v-table/v3'
import {VIcon} from 'vuetify/lib'
import {mapGetters} from 'vuex'
import AdjustPop from './AdjustPop'
import { getsafe } from '@/libs/util.js'
import { formattingNumber } from '@/libs/util.js'
import employmentTypesMixin from '@/views/fin/salaryadministration/common_mixins.js'
import PayAdjustModal from '@/views/fin/salaryadministration/components/PayAdjustModal.jsx'
import {status_list} from '@/views/fin/salaryadministration/fields.js'
import PopTip from '@/views/fin/salaryadministration/components/PopTip.vue'
import styles from './pay.module.less'
export const remark_list_color_hash = status_list.reduce((total, item) => {
    item.key.forEach(key => {
        total[key] = item
    })
    return total
}, {})
const order_keys = ['current_change_flag', 'current_quit_flag', 'current_medical_period_flag', 'pre_medical_period_flag', 'same_name_flag']
export default {
    mixins:[employmentTypesMixin],
    props: {
        workingDayTip: {
            type: String,
            default: () => ''
        },
        loading: {
            type: Boolean,
            default: () => false
        },
    },
    data() {
        return {
            end_date: null,
            begin_date: null,
            records: [],
            modify_hash: {},
            customer_type_change_hash: {},
            awardHash: {},
            customer_type_list: [],
            pigeonhole_flag:0,
            is_expand: false,
        }
    },
    methods: {
        itemRender(...arg) {
            const header = arg[4]
            const target = arg[1]
            return <span style="font-weight:bold">{formattingNumber(target[header.value], 2)}</span>
        },
        getClass({item}) {
            let className = ''
            order_keys.forEach(key => {
                if (item && item[key] && !className) {
                    className = remark_list_color_hash[key].className
                }
            })
            return className
        },
        setParams({end_date = '', begin_date = '', records = [], modify_hash = {}, customer_type_list = [], customer_type_change_hash = {}, pigeonhole_flag} = {}) {
            this.end_date = end_date
            this.begin_date = begin_date
            this.records = records
            this.modify_hash = modify_hash
            this.customer_type_change_hash = customer_type_change_hash
            this.customer_type_list = customer_type_list
            this.pigeonhole_flag = pigeonhole_flag
          
        },
        adjustPop(current, unit) {
            return current && <AdjustPop item={{
                ...current,
                sys_value: current.sys_value || 0
            }} unit={unit}/>
        },
        adjustSocialPop(current) {
            if (!current) {
                return 
            }
            const current_c = {
                sys_value: Number(current.sys_value) === 1 ? '正常缴纳' : '不缴纳',
                adjust_value: Number(current.adjust_value) === 1 ? '正常缴纳' : '不缴纳',
                reason: current.reason
            }
            return <AdjustPop item={current_c} unit=''/>
        },
        tableHeader({props}) {
            return <thead
                        class="v-data-table-header"
                    >
                    <tr>
                        {props.headers.filter(item => !item.is_parent || (item.is_parent && item.parent_text)).map(item => {
                            
                            return <th 
                                colspan={item.cols || 1}
                                rowspan={item.parent_text ? 1 : 2}
                                role="columnheader"
                                style={{
                                    ...item.style,
                                    'min-width': item.width + 'px',
                                    'z-index': item.fixed ? 2 : 1
                                }}
                                class={ [styles['td-font'], styles['th-f'], styles['fixed-sticky']].join(' ')}
                            >{item.parent_text || item.text} {!item.parent_text && item.icon }</th>
                        })}
                    </tr>
                    <tr>
                        {props.headers.filter(item => (item.is_parent)).map(item => {
                            return <th role="columnheader"
                                class={styles['th-f']}
                                style={{
                                    ...item.style,
                                    'min-width': item.width + 'px',
                                    'z-index': item.fixed ? 2 : 1
                                }}
                             //    class={ [styles['td-font'], styles['fixed-sticky']].join(' ')}
                            >{item.text} {item.icon }</th>
                        })}
                    </tr>
        </thead>
        },
        handleModify(item) {
            return Object.values(this.modify_hash || {}).filter(i => i.customer_month_salary_detail_id === item.id)
        },
        adjust(target) {
       
            this.$refs['adjust'].edit(target)
        }
    },
    computed:{
        // this.$store.state.window_height
        table_height() {
            const height = this.$store.state.window_height - 200
            const len = getsafe(this.records, 'length', 0) + 1
            return Math.min(height, len * 48 + 10)
        },
        customer_type_list_hash() {
            const obj = {}
            this.customer_type_list.forEach(item => {
                if (!obj[item.customer_type]) {
                    obj[item.customer_type] = {}
                }
                obj[item.customer_type][item.customer_sub_type] = item
            });
            return obj
        },
        is_market() {
            const list = this.customer_type_list.reduce((total, item) => {
                total.push(`${item.customer_type}-${item.customer_sub_type}`)
                return total
            }, [])
            return list.includes('50-0')
        },
        ...mapGetters('async', {
            customer_types: 'customer_types',
          }),
          customer_types_hash() {
              return this.customer_types.reduce((total, item) => {
                total[item.key] = item
                return total
              }, {})
          },
        headers() {
            return [
                {
                    text: '工号',
                    align: 'center',
                    fixed: 'left',
                    // 
                    value: 'job_number',
                    width: 100,
                    z_index:1,
                    tdClass: this.getClass
                },
                {
                    text: '姓名',
                    align: 'center',
                    fixed: 'left',
                    // 
                    value: 'customer_name',
                    width: 100,
                    tdClass: this.getClass,
                    z_index:1,
                },
                {
                    text: '身份证',
                    align: 'center',
                    value: 'id_number',
                    width: 120,
           
                },
                {
                    text: '银行卡号',
                    align: 'center',
                    value: 'bank_number',
                    width: 120,
           
                },
                {
                    text: '劳动关系所在公司	',
                    align: 'center',
                    value: 'company_name',
                    width: 130,
                
           
                },
                {
                    text: '状态',
                    align: 'center',
                    value: 'emp_status',
                    width: 120,
                    // status_list
                },
                {
                    text: '缴存地',
                    align: 'center',
                    value: 'payment_place',
                    width: 120,
           
                },
                {
                    text: '分类',
                    align: 'center',
                    value: 'customer_type',
                    width: 120,
                },
                {
                    text: '团队',
                    align: 'center',
                    value: 'team_name',
                    width: 120,
                },
                {
                    text: '当月应出勤天数',
                    align: 'center',
                    value: 'should_working_day',
                    width: 120,
                },
                {
                    text: '当月入离职调整天数',
                    align: 'center',
                    value: 'enter_quit_adjust_day',
                    width: 140,
                    render: (...arg) => {
                 
                        const target = arg[1]
                        return <span style={{
                            color:Number(target.enter_quit_adjust_day) > 0 && 'red'
                        }}>{target.enter_quit_adjust_day}</span>
                    },
                    show: () => this.is_expand 
                },
                {
                    text: '当月请假需扣除天数',
                    align: 'center',
                    value: 'leave_day',
                    width: 140,
                    show: () => this.is_expand 
                },
            
                {
                    text: '上月补发天数',
                    align: 'center',
                    value: 'last_month_working_day',
                    width: 120,
                    show: () => this.is_expand 
                },
                {
                    text: '当月出勤调整天数',
                    headerRender:({header}) => {
                        return <span>
                            <VIcon 
                                small 
                                style="cursor: pointer;" 
                                color="primary"
                                on={{
                                    click: () => {
                                        this.is_expand = !this.is_expand
                                    }
                                }}
                                >{this.is_expand ? 'mdi-arrow-collapse-horizontal' : 'mdi-arrow-expand-horizontal'}</VIcon>{header.text}</span>
                    },
                    align: 'center',
                    value: 'work_day',
                    width: 180,
                    render: this.itemRender
                },
                {
                    text: '税前基准工资',
                    
                    value: 'salary',
                    width: 120,
                    align: 'center',
                    type: 'money_field'
                },
                {
                    text: '入离职调整工资',
                    
                    value: 'enter_quit_adjust_salary',
                    width: 120,
                    type: 'money_field',
                    align: 'center',
                    render: (_, target) => {
                        return <span style={{
                            color:Number(target.enter_quit_adjust_day) > 0 && 'red'
                        }}>{formattingNumber(target.enter_quit_adjust_salary, 2)}</span>
                    }
                },
                {
                    text: '上月补发工资',
                    
                    value: 'last_month_supply_salary',
                    width: 120,
                    type: 'money_field',
                    align: 'center',
                },
                {
                    text: '请假扣款',
                    
                    value: 'leave_deduct_salary',
                    width: 120,
                    type: 'money_field',
                    align: 'center',
                },
                {
                    text: '其他发放',
                    
                    value: 'other_subsidy',
                    width: 120,
                    type: 'money_field',
                    align: 'center',
                    render: (...arg) => {
                        const header = arg[4]
                        const target = arg[1]
                        return <span style="font-weight:bold">{formattingNumber(target[header.value], 2)} 
                         {!!target.other_subsidy_memo && <PopTip showIcon size={14} title={target.other_subsidy_memo}/>}</span>
                    }
                },
                {
                    text: '当期调整合计',
                    
                    value: 'current_period_adjust',
                    width: 120,
                    type: 'money_field',
                    align: 'center',
                    render: this.itemRender
                },
                {
                    text: '标准餐补',
                    
                    value: 'meal_subsidy_base',
                    width: 120,
                    type: 'money_field',
                    align: 'center',
                },
                {
                    text: '餐补',
                    
                    value: 'meal_subsidy',
                    width: 120,
                    type: 'money_field',
                    align: 'center',
                },
                {
                    text: '推荐奖',
                    
                    value: 'recommend_award',
                    width: 120,
                    type: 'money_field',
                    align: 'center',
                },
                {
                    text: '税前工资',
                    value: 'customer_salary',
                    width: 120,
                    type: 'money_field',
                    align: 'center',
                    render: this.itemRender
                },
                {
                    text: '社保基数-养老',
                    
                    value: 'endowment_insurance_payment_base',
                    width: 120,
                    type: 'money_field',
                    align: 'center',
                },
                {
                    text: '社保基数-其他',
                    
                    value: 'medical_insurance_payment_base',
                    width: 120,
                    type: 'money_field',
                    align: 'center',
                },
                {
                    text: '公积金基数',
                    
                    value: 'accumulation_fund_payment_base',
                    width: 120,
                    type: 'money_field',
                    align: 'center',
                },
                {
                    text: '养老单位缴费金额',
                    
                    value: 'company_endowment_amount',
                    width: 130,
                    type: 'money_field',
                    align: 'center',
                },
                {
                    text: '医疗单位缴费金额',
                    
                    value: 'company_medical_amount',
                    width: 130,
                    type: 'money_field',
                    align: 'center',
                },
                {
                    text: '生育单位缴费金额',
                    
                    value: 'company_maternity_amount',
                    width: 130,
                    type: 'money_field',
                    align: 'center',
                },
                {
                    text: '失业单位缴费金额',
                    
                    value: 'company_unemployment_amount',
                    width: 130,
                    type: 'money_field',
                    align: 'center',
                },
                {
                    text: '工伤单位缴费金额',
                    
                    value: 'company_industrial_injury_amount',
                    width: 130,
                    type: 'money_field',
                    align: 'center',
                },
                {
                    text: '补充医疗单位缴费金额',
                    
                    value: 'company_supplementary_medical_amount',
                    width: 130,
                    type: 'money_field',
                    align: 'center',
                    // render: (_, __, target) => {
                    
                    //     if (target.payment_place === '北京') {
                    //         return <span>-</span>
                    //     }
                    //     return <span >{ formattingNumber(target.company_supplementary_medical_amount || 0, 2)}</span>
                    // },
                },
                {
                    text: '公积金单位缴存额',
                    
                    value: 'company_accumulation_fund_amount',
                    width: 130,
                    type: 'money_field',
                    align: 'center',
                },
                {
                    text: '养老个人缴费金额',
                    
                    value: 'person_endowment_amount',
                    width: 130,
                    type: 'money_field',
                    align: 'center',
                },
                {
                    text: '医疗个人缴费金额',
                    
                    value: 'person_medical_amount',
                    width: 130,
                    type: 'money_field',
                    align: 'center',
                    
                },
                {
                    text: '失业个人缴费金额',
                    
                    value: 'person_unemployment_amount',
                    width: 130,
                    type: 'money_field',
                    align: 'center',
                },
                {
                    text: '补充医疗个人缴费金额',
                    
                    value: 'person_supplementary_medical_amount',
                    width: 130,
                    type: 'money_field',
                    align: 'center',
                    // render: (_, __, target) => {
                    
                    //     if (target.payment_place === '成都') {
                    //         return <span>-</span>
                    //     }
                    //     return <span >{ formattingNumber(target.person_supplementary_medical_amount, 2)}</span>
                    // },
                },
                {
                    text: '公积金个人缴存额',
                    
                    value: 'person_accumulation_fund_amount',
                    width: 130,
                    type: 'money_field',
                    align: 'center',
                },
                {
                    text: '个人扣除',
                    
                    value: 'person_deduct_amount',
                    width: 120,
                    type: 'money_field',
                    align: 'center',
                    render: this.itemRender
                },
                {
                    text: '子女教育',
                    
                    value: 'child_edu_deduct',
                    width: 120,
                    type: 'money_field',
                    align: 'center',
                },
                {
                    text: '住房贷款利息',
                    
                    value: 'housing_loan_deduct',
                    width: 120,
                    type: 'money_field',
                    align: 'center',
                },
                {
                    text: '住房租金',
                    
                    value: 'housing_rent_deduct',
                    width: 120,
                    type: 'money_field',
                    align: 'center',
                },
                {
                    text: '赡养老人',
                    
                    value: 'support_older_deduct',
                    width: 120,
                    type: 'money_field',
                    align: 'center',
                },
                {
                    text: '继续教育',
                    
                    value: 'continuing_edu_deduct',
                    width: 120,
                    type: 'money_field',
                    align: 'center',
                },
                {
                    text: '婴幼儿照护',
                    
                    value: 'baby_tend_deduct',
                    width: 120,
                    type: 'money_field',
                    align: 'center',
                },
                {
                    text: '专项附加扣除汇总',
                    
                    value: 'special_deduct_total',
                    width: 130,
                    type: 'money_field',
                    align: 'center',
                    render: this.itemRender
                },
                {
                    text: '个人养老金',
                    value: 'personal_pension',
                    width: 130,
                    type: 'money_field',
                    align: 'center',
                },
                {
                    text: '扣除三险一金后月税前工资',
                    
                    value: 'pre_tax_salary',
                    width: 120,
                    type: 'money_field',
                    align: 'center',
                },
                {
                    text: '个税',
                    
                    value: 'individual_tax',
                    width: 120,
                    type: 'money_field',
                    align: 'center',
                },
                {
                    text: '税后工资',
                    
                    value: 'after_tax_salary',
                    width: 120,
                    type: 'money_field',
                    align: 'center',
                    render:(...arg) => {
                        const header = arg[4]
                        const target = arg[1]
                        return <span style={`font-weight:bold;color:${Number(target[header.value]) < 0 ? 'red' : ''}`}>{formattingNumber(target[header.value], 2)}</span>
                    }
                },
                {
                    text: '公司社保合计',
                    
                    value: 'company_social_security_total',
                    width: 120,
                    type: 'money_field',
                    align: 'center',
                },
                {
                    text: '个人社保合计',
                    
                    value: 'person_social_security_total',
                    width: 120,
                    type: 'money_field',
                    align: 'center',
                },
                {
                    text: '社保合计',
                    
                    value: 'social_security_total',
                    width: 120,
                    type: 'money_field',
                    align: 'center',
                },
                {
                    text: '公积金合计',
                    
                    value: 'accumulation_fund_total',
                    width: 120,
                    type: 'money_field',
                    align: 'center',
                },
                {
                    text: '离职补偿金',
                    
                    value: 'severance',
                    width: 120,
                    type: 'money_field',
                    align: 'center',
                },
                {
                    text: '竞业补偿金',
                    
                    value: 'non_competition',
                    width: 120,
                    type: 'money_field',
                    align: 'center',
                },
                {
                    text: '期权',
                    
                    value: 'option',
                    width: 120,
                    type: 'money_field',
                    align: 'center',
                },
                {
                    text: '离职补偿总计',
                    value: 'total_severance',
                    width: 120,
                    type: 'money_field',
                    align: 'center',
                },
                {
                    text: '离职补偿金个税',
                    
                    value: 'severance_tax',
                    width: 120,
                    type: 'money_field',
                    align: 'center',
                },
                {
                    text: '离职补偿税后实发',
                    
                    value: 'after_tax_severance',
                    width: 130,
                    type: 'money_field',
                    align: 'center',
                },
                {
                    text: '操作',
                    align: 'center',
                    value: 'action',
                    width: 100,
                    fixed: 'right',
                    tdClass: this.getClass,
                    type: 'button_g_field',
                    z_index:1,
                    buttons: [
                  
                      {
                        text: '调整',
                        key: 'edit',
                        color: 'primary',
                        small: true,
                        _text: true,
                        callback: this.adjust
                      },
                    ]
                }
            ].filter(i => {
                if (!i.show) {
                    return true
                }
                return i.show()
            })
        }
    },
    watch: {
        selected(val) {
            this.$emit('selectedChange', val)
        }
    },
    render() {
        return <div>
            <div style={{
                height: `${this.table_height}px`
            }}>
                <VTable
                    fixedHeader
                    fixedHeaderZindex={3}
                    headers={this.headers}
                    desserts={this.records}
                    loading={this.loading}
                    rowClass={this.getClass}
                />
            </div>
            <PayAdjustModal 
                ref="adjust"
                on={{
                    success: () => {
                        this.$emit('adjustSuccess')
                    }
                }}
            />
        </div>
    }
}